import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const newRovoSearchRoute: InvariantJiraRoute = {
	name: 'jira-rovo-search-new',
	path: '/jira/rovo-search',
	exact: true,
};
